/**
 * Attribution: https://easings.net/
 */
export const easeOutCubic: string = `cubic-bezier(0.33, 1, 0.68, 1)`;
